export default __webpack_public_path__ + "static/media/seating.cb3e612d.svg";